import Tooltip from './tooltip';

export default {
  init: function (selector) {
    const tooltips = document.querySelectorAll(selector);

    if (tooltips && tooltips.length) {
      [...tooltips].map(item => {
        const tooltip = new Tooltip(item);
        tooltip.init();
      });
    }
  }
};
